/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ENSOutreachPlanInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Outreach Strategy Action Plan"
              description={
               <>
               <h4>Elections Nova Scotia&#39;s Outreach Strategy Action Plan</h4>
                  <br />
                  <p>In collaboration with our IDEAs partners (inclusion, diversity, equity and accessibility) Elections Nova Scotia has developed an Outreach Strategy Action Plan to guide our outreach work for the 43rd Provincial General Election when it is called. </p>
                  <br />
                  <p>We have heard loud and clear that while progress has been made, challenges remain for underserved voters when accessing the electoral process. Our IDEAs program is not just about recognizing those challenges; it is about taking concrete steps to address them.</p>
                  <br />
                  <p>Our approach to outreach is long-term, requiring ongoing collaboration, support, and dedication. Together with our IDEAs partners we will continue to work to create change for underserved voters across Nova Scotia.</p>
                  <br />
                  <p>Please click here to view the <u><a href="/files/AnnualAndOtherReports/OutreachStrategyActionPlan_IDEAs_FINAL.pdf">Outreach Strategy Action Plan.</a></u> </p>
               </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ENSOutreachPlanInformation;
